import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '../../../plugins/publicis-gatsby-plugin-i18n';
import { CloseIconThin, RoundedArrow } from '../../Atoms/Icons/Icons';
import SearchBar from '../../Molecules/SearchBar/SearchBar';

import './PopinSearchOnSite.scss';

let classNames = require('classnames');
const axios = require('axios').default;

const PopinSearchOnSite = ({ openSearchPopin, onToggleOpenPropsFunc }) => {
  const popinRef = useRef();
  const intl = useIntl();
  const [searchResult, setSearchResult] = useState([]);
  const [defVal, setDefVal] = useState(false);
  const [contentType, setContentTypeState] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [isZeroResult, setIsZeroResult] = useState(false);

  useEffect(() => {
    if (popinRef.current) {
      popinRef.current.addEventListener('keydown', onKeyPressed)
      return () => { popinRef.current ? popinRef.current.removeEventListener('keydown', onKeyPressed) : null };
    }
  }, [])

  const onKeyPressed = (e) => {
    if (e.keyCode === 9 && e.target.classList.contains('close_search')) {
      e.preventDefault();
      popinRef.current.querySelectorAll('input[type="text"]')[0].focus();
    }
  }

  const onCloseSearchBar = (e) => {
    e.preventDefault();
    document.body.classList.remove('popin_open');
    onToggleOpenPropsFunc(false);
    setSearchResult([]);
    setDefVal(true);
    setIsSearching(false);
    setIsZeroResult(false);
  };

  const setContentType = (type) => {
    let tempArr = contentType;
    let typeName = '';

    switch (type) {
      case 'd17eadd4-5176-4188-9a59-77ccd103d59f':
        typeName = intl.formatMessage({ id: 'media.categories.actuality' });
        break;

      case '9ab92d51-116b-4598-afff-e60097a3ab45':
        typeName = intl.formatMessage({ id: 'media.categories.press' });
        break;

      case '2fb9fd8b-026b-4575-9fc7-32e3df3560da':
        typeName = intl.formatMessage({ id: 'media.categories.publications' });
        break;

      case 'node--webform':
      case 'node--page_contact':
        typeName = intl.formatMessage({ id: 'search.types.forms' });
        break;

      case 'node--agenda':
        typeName = intl.formatMessage({ id: 'search.types.agenda' });
        break;

      case 'node--activites':
        typeName = intl.formatMessage({ id: 'search.types.activities' });
        break;

      case 'node--assemblee_generale':
        typeName = intl.formatMessage({ id: 'search.types.generalAssembly' });
        break;

      case 'node--biographie':
        typeName = intl.formatMessage({ id: 'search.types.biography' });
        break;

      case 'node--finance':
        typeName = intl.formatMessage({ id: 'search.types.finance' });
        break;

      case 'node--histoire':
        typeName = intl.formatMessage({ id: 'search.types.history' });
        break;

      default:
        typeName = intl.formatMessage({ id: 'search.types.others' });
        break;
    }

    !contentType.find(i => typeName === i) ? tempArr.push(typeName) : null;
    setContentTypeState(tempArr);
    return typeName;
  };

  const onSearchSubmit = (e, value) => {
    setSearchResult([]);
    setContentType([]);
    setIsSearching(true);
    if (window._paq) {
      console.log('trackSiteSearch', "internal_search", value);
      _paq.push(['trackSiteSearch', "internal_search", value, 0]);
    }
    e.preventDefault();
    axios.get(`${process.env.GATSBY_DRUPAL_BASE_URL}${intl.locale}/jsonapi/index/node`, {
      params: {
        'filter[my-search][group][conjunction]': 'OR',
        'filter[title-filter][condition][path]': 'title',
        'filter[title-filter][condition][operator]': 'IN',
        'filter[title-filter][condition][value]': value,
        'filter[title-filter][condition][memberOf]': 'my-search',
        'filter[taxonomy_term--tags][condition][path]': 'name',
        'filter[taxonomy_term--tags][condition][operator]': 'IN',
        'filter[taxonomy_term--tags][condition][value]': value,
        'filter[taxonomy_term--tags][condition][memberOf]': 'my-search'
      }

    })
      .then(result => {
        let tempArr = [];

        result.data.data.forEach((data) => {
          let catID = data?.relationships?.field_category?.data?.id;

          tempArr.push({
            title: data?.attributes?.title,
            path: '/' + data?.attributes?.path?.langcode + data?.attributes?.path?.alias,
            type: data?.type == 'node--article' ? setContentType(catID) : setContentType(data?.type)
          });
        });

        setSearchResult(tempArr);
        setIsSearching(false);
        setIsZeroResult((tempArr.length < 1) ? true : false);
      })
      .catch((response) => {
        console.error(response);

        setSearchResult([]);
        setIsSearching(false);
        setIsZeroResult(false);
      });
  };

  return (
    <div className={classNames('popin_search_on_site', { 'is_open': openSearchPopin })} role="dialog" aria-labelledby="modaltitle" id="popin_search_on_site" ref={popinRef}>
      <div className="top_bar">
        <SearchBar
          onSearchSubmit={(e, value) => onSearchSubmit(e, value)}
          placeholder={intl.formatMessage({ id: 'search.cta.placeholder' })}
          buttonLabel={intl.formatMessage({ id: 'search.cta.search' })}
          defVal={defVal}
          isOpen={openSearchPopin}
          ariaLabel={intl.formatMessage({ id: 'search.cta.placeholder' })}
          roleProp="search"
          uniqueID="search_on_site"
        />
        <a href="#" className="close_search" onClick={onCloseSearchBar} aria-label={intl.formatMessage({ id: 'ariaLabel.close_popin_search' })}>
          <CloseIconThin />
          <FormattedMessage id="common.close">{x => <span>{x}</span>}</FormattedMessage>
        </a>
      </div>
      <div className="search_info_text">
        {isSearching && <div className="search_progress">{intl.formatMessage({ id: 'search.searchProgress' })}</div>}
      </div>
      {
        searchResult.length > 0 ? (
          <div className="result_container">
            <div className="nb_results">
              <p className="big">{searchResult.length}</p>
              <p><FormattedMessage id="search.result" /></p>
            </div>
            <div className="search_results">

              {contentType.map((cType, key) => (
                searchResult.filter(a => a.type === cType).length > 0 && <div className="category" key={key}>
                  <h3>
                    <RoundedArrow />
                    {cType}
                  </h3>
                  <ul>
                    {searchResult.map((item, i) => (

                      item.type == cType &&
                      <li key={i}>
                        <a href={item.path}>{item.title}</a>
                      </li>

                    ))}

                  </ul>
                </div>
              ))}

            </div>
          </div>
        ) : (
          <div className="search_info_text">{isZeroResult && !isSearching && <p aria-live="polite">{intl.formatMessage({ id: 'search.zeroResult' })}</p>}</div>
        )
      }
    </div>
  );
};

PopinSearchOnSite.propTypes = {
  intl: PropTypes.object
};

export default PopinSearchOnSite;
